import React, { Component } from 'react';
import axios from 'axios';
//https://api.antikbet.dev:1881';
const API        = 'https://api.antikbet.dev:1881';
const DESTEK_URL = 'https://vue.comm100.com/chatwindow.aspx?siteId=85000541&planId=e03ab936-83fb-4dcc-91d7-44d91407fd84';

/* ─── Renk paleti — #131028 bazlı ─── */
const P = {
  bg:        '#131028',
  bgDeep:    '#0e0b1e',
  bgLight:   '#1a1535',
  card:      'rgba(255,255,255,.045)',
  cardHov:   'rgba(255,255,255,.07)',
  border:    'rgba(255,255,255,.08)',
  borderStr: 'rgba(255,255,255,.13)',
  text:      '#f0eeff',
  textSub:   'rgba(240,238,255,.45)',
  textFaint: 'rgba(240,238,255,.22)',
  accent:    '#f27127',
  accentDim: 'rgba(242,113,39,.18)',
  accentGlow:'rgba(242,113,39,.32)',
  purple:    '#a78bfa',
  purpleDim: 'rgba(167,139,250,.14)',
};

/* ─── Kategori ikonları ─── */
const KAT_IKONLAR = {
  'casino':'🎰','spor':'⚽','canlı casino':'🃏','canlı spor':'🏆',
  'slot':'🎲','poker':'♠️','freespin':'🌀','default':'🎁',
};
const katIcon = (name='') => {
  const n = name.toLowerCase();
  for (const k of Object.keys(KAT_IKONLAR))
    if (k !== 'default' && n.includes(k)) return KAT_IKONLAR[k];
  return KAT_IKONLAR.default;
};

/* ─── Kopyala util ─── */
const kopyala = (text, cb) => {
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(cb).catch(()=>{});
  } else {
    const el = document.createElement('textarea');
    el.value = text; document.body.appendChild(el); el.select();
    document.execCommand('copy'); document.body.removeChild(el); cb?.();
  }
};

/* ─── Bildirim yöneticisi ─── */
let _nid = 0;
class NotifManager {
  constructor() { this._s = []; }
  subscribe(fn) { this._s.push(fn); return () => { this._s = this._s.filter(x=>x!==fn); }; }
  emit(n) { this._s.forEach(fn=>fn({ id:++_nid, ...n })); }
}
const notifMgr = new NotifManager();

/* ─── Bildirim overlay ─── */
class NotifOverlay extends Component {
  state = { items:[] };
  unsub = null;
  componentDidMount() {
    this.unsub = notifMgr.subscribe(n => {
      this.setState(p=>({ items:[n,...p.items].slice(0,5) }));
      setTimeout(()=>this.setState(p=>({ items:p.items.filter(i=>i.id!==n.id) })),5500);
    });
  }
  componentWillUnmount() { this.unsub?.(); }
  colors(type) {
    return ({
      success:{ bg:'rgba(16,185,129,.15)', border:'rgba(16,185,129,.35)', accent:'#10b981', icon:'✓' },
      error:  { bg:'rgba(239,68,68,.14)',  border:'rgba(239,68,68,.35)',  accent:'#ef4444', icon:'✕' },
      info:   { bg:'rgba(139,92,246,.14)', border:'rgba(139,92,246,.35)', accent:'#8b5cf6', icon:'ℹ' },
      warn:   { bg:'rgba(245,158,11,.14)', border:'rgba(245,158,11,.35)', accent:'#f59e0b', icon:'!' },
      copy:   { bg:'rgba(167,139,250,.13)',border:'rgba(167,139,250,.35)',accent:'#a78bfa', icon:'⎘' },
    })[type] || { bg:'rgba(255,255,255,.07)', border:P.border, accent:'#94a3b8', icon:'•' };
  }
  render() {
    return (
      <div style={{ position:'fixed',top:16,right:16,zIndex:9999,display:'flex',flexDirection:'column',gap:9,maxWidth:340,width:'calc(100vw - 32px)',pointerEvents:'none' }}>
        {this.state.items.map(item => {
          const c = this.colors(item.type);
          return (
            <div key={item.id} style={{ background:c.bg, border:`1px solid ${c.border}`, borderRadius:14, padding:'13px 15px', backdropFilter:'blur(20px)', boxShadow:'0 8px 32px rgba(0,0,0,.6)', animation:'notifIn .3s cubic-bezier(.175,.885,.32,1.275)', display:'flex', alignItems:'flex-start', gap:11 }}>
              <span style={{ width:24,height:24,borderRadius:'50%',background:c.accent,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.7rem',fontWeight:800,flexShrink:0,marginTop:1 }}>{c.icon}</span>
              <div style={{ flex:1,minWidth:0 }}>
                {item.title && <div style={{ fontSize:'.8rem',fontWeight:700,color:P.text,marginBottom:item.body?3:0,lineHeight:1.3 }}>{item.title}</div>}
                {item.body  && <div style={{ fontSize:'.74rem',color:P.textSub,lineHeight:1.45 }}>{item.body}</div>}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

/* ─── Beklemede canlı progress bar ─── */
class PendingBar extends Component {
  DURATION = 30000; // 30 saniye
  state = { pct: 0 };

  componentDidMount() {
    const elapsed = Date.now() - new Date(this.props.createdAt).getTime();
    const start   = Math.min(elapsed / this.DURATION, 1) * 100;
    this.setState({ pct: start });

    if (start < 100) {
      this._iv = setInterval(() => {
        const e2  = Date.now() - new Date(this.props.createdAt).getTime();
        const pct = Math.min(e2 / this.DURATION, 1) * 100;
        this.setState({ pct });
        if (pct >= 100) clearInterval(this._iv);
      }, 200);
    }
  }
  componentWillUnmount() { clearInterval(this._iv); }

  render() {
    const { pct } = this.state;
    const done    = pct >= 100;
    return (
      <div style={{ padding:'12px 15px 14px', borderTop:'1px solid rgba(167,139,250,.1)', background:'rgba(167,139,250,.04)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:7 }}>
          <span style={{ fontSize:'.6rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.8px', color:'rgba(167,139,250,.5)' }}>
            {done ? 'İnceleniyor' : 'İşleme Alınıyor'}
          </span>
          <span style={{ fontSize:'.65rem', fontWeight:700, color:'#a78bfa' }}>{Math.round(pct)}%</span>
        </div>
        <div style={{ height:6, borderRadius:99, background:'rgba(167,139,250,.12)', overflow:'hidden' }}>
          <div style={{
            height:'100%', borderRadius:99,
            background:'linear-gradient(90deg, #7c3aed, #a78bfa, #c4b5fd)',
            backgroundSize:'200% 100%',
            width:`${pct}%`,
            transition:'width .22s linear',
            animation: done ? 'none' : 'pbShimmer 2.2s linear infinite, pbPulse 2s ease-in-out infinite',
            boxShadow:'0 0 10px rgba(167,139,250,.5)',
          }} />
        </div>
        <div style={{ fontSize:'.58rem', color:'rgba(167,139,250,.35)', marginTop:6 }}>
          {done ? 'Operatörünüz talebinizi değerlendiriyor…' : 'Operatörünüz talebinizi inceliyor…'}
        </div>
      </div>
    );
  }
}

/* ─── Bonus detay bottom sheet ─── */
class BonusDetayModal extends Component {
  state = { detay: null, yukleniyor: false };

  componentDidMount() {
    if (this.props.bonus?.id) this.fetchDetay(this.props.bonus.id);
  }
  componentDidUpdate(pp) {
    if (this.props.bonus?.id && this.props.bonus.id !== pp.bonus?.id) {
      this.fetchDetay(this.props.bonus.id);
    }
  }

  fetchDetay = async (id) => {
    this.setState({ yukleniyor:true, detay:null });
    try {
      const r = await axios.get(`${API}/bonus/${id}`);
      this.setState({ detay: r.data });
    } catch { /* sessiz */ }
    finally { this.setState({ yukleniyor:false }); }
  };

  render() {
    const { bonus, onKapat } = this.props;
    if (!bonus) return null;
    const { detay, yukleniyor } = this.state;

    const finansal = [
      bonus.bonusPercent > 0      && { label:'Bonus Oranı',   val:`%${bonus.bonusPercent}`,                              icon:'🎯', color:'#f59e0b', glow:'rgba(245,158,11,.18)' },
      bonus.minDepositAmount > 0  && { label:'Min. Yatırım',  val:`${bonus.minDepositAmount.toLocaleString('tr-TR')} ₺`, icon:'💳', color:'#a78bfa', glow:'rgba(167,139,250,.14)' },
      bonus.maxDepositAmount > 0  && { label:'Max. Yatırım',  val:`${bonus.maxDepositAmount.toLocaleString('tr-TR')} ₺`, icon:'💳', color:'#a78bfa', glow:'rgba(167,139,250,.14)' },
      bonus.minAmount > 0         && { label:'Min. Bonus',    val:`${bonus.minAmount.toLocaleString('tr-TR')} ₺`,        icon:'💰', color:'#10b981', glow:'rgba(16,185,129,.14)'  },
      bonus.maxAmount > 0         && { label:'Max. Bonus',    val:`${bonus.maxAmount.toLocaleString('tr-TR')} ₺`,        icon:'💰', color:'#10b981', glow:'rgba(16,185,129,.14)'  },
    ].filter(Boolean);

    const satirlar = (detay?.description || []).filter(s => s.trim() !== '');

    return (
      <div onClick={onKapat} style={{ position:'fixed', inset:0, zIndex:10000, background:'rgba(5,3,15,.85)', backdropFilter:'blur(16px)', display:'flex', alignItems:'flex-end', justifyContent:'center', animation:'overlayIn .22s ease' }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'100%', maxWidth:520, background:`linear-gradient(180deg, #1c1535 0%, #161130 100%)`, borderRadius:'26px 26px 0 0', border:`1px solid rgba(167,139,250,.15)`, borderBottom:'none', animation:'sheetUp .34s cubic-bezier(.175,.885,.32,1.05)', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

          {/* Dekoratif üst ışık */}
          <div style={{ position:'absolute', top:0, left:'50%', transform:'translateX(-50%)', width:220, height:1, background:'linear-gradient(90deg, transparent, rgba(167,139,250,.5), transparent)', borderRadius:99 }} />

          {/* Handle */}
          <div style={{ width:40, height:4, borderRadius:4, background:'rgba(167,139,250,.25)', margin:'14px auto 0', flexShrink:0 }} />

          {/* Hero başlık */}
          <div style={{ padding:'18px 22px 16px', flexShrink:0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:14 }}>
              {/* Animasyonlu ikon kutusu */}
              <div style={{ width:52, height:52, borderRadius:16, background:'linear-gradient(135deg, rgba(242,113,39,.2), rgba(242,113,39,.06))', border:'1px solid rgba(242,113,39,.3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.5rem', flexShrink:0, boxShadow:'0 8px 24px rgba(242,113,39,.2), inset 0 1px 0 rgba(255,255,255,.06)' }}>
                🎁
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:'1rem', fontWeight:800, color:'#f0eeff', letterSpacing:'-.3px', marginBottom:4, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {bonus.name}
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <span style={{ width:6, height:6, borderRadius:'50%', background:'#10b981', display:'inline-block', animation:'pulseDot 2s infinite' }} />
                  <span style={{ fontSize:'.68rem', color:'rgba(167,139,250,.6)', fontWeight:600 }}>Bonus Detayları</span>
                </div>
              </div>
            </div>
          </div>

          {/* İnce ayırıcı */}
          <div style={{ height:1, background:'linear-gradient(90deg, transparent, rgba(167,139,250,.15), transparent)', margin:'0 22px', flexShrink:0 }} />

          {/* Kaydırılabilir gövde */}
          <div style={{ overflowY:'auto', flex:1, padding:'18px 22px 6px' }} className="detay-scroll">

            {/* Finansal grid */}
            {finansal.length > 0 && (
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:'.58rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.2px', color:'rgba(167,139,250,.4)', marginBottom:10 }}>Kısaca</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                  {finansal.map((s, i) => (
                    <div key={i} style={{ padding:'12px 14px', borderRadius:14, background:`linear-gradient(135deg, ${s.glow}, rgba(255,255,255,.02))`, border:`1px solid ${s.color}28`, position:'relative', overflow:'hidden' }}>
                      {/* Köşe parlaması */}
                      <div style={{ position:'absolute', top:-10, right:-10, width:40, height:40, borderRadius:'50%', background:s.glow, filter:'blur(12px)', pointerEvents:'none' }} />
                      <div style={{ fontSize:'1rem', marginBottom:6 }}>{s.icon}</div>
                      <div style={{ fontSize:'.58rem', color:'rgba(240,238,255,.3)', textTransform:'uppercase', letterSpacing:'.8px', marginBottom:4 }}>{s.label}</div>
                      <div style={{ fontSize:'.92rem', fontWeight:800, color:s.color, letterSpacing:'-.2px' }}>{s.val}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Açıklama maddeleri */}
            {yukleniyor ? (
              <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:18 }}>
                <div style={{ fontSize:'.58rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.2px', color:'rgba(167,139,250,.4)', marginBottom:2 }}>Koşullar & Açıklamalar</div>
                {[80, 100, 65].map((w, i) => (
                  <div key={i} style={{ height:58, borderRadius:14, backgroundImage:'linear-gradient(90deg,rgba(167,139,250,.04) 0%,rgba(167,139,250,.1) 50%,rgba(167,139,250,.04) 100%)', backgroundSize:'200% 100%', animation:'shimmer 1.6s infinite' }} />
                ))}
              </div>
            ) : satirlar.length > 0 && (
              <div style={{ marginBottom:18 }}>
                <div style={{ fontSize:'.58rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.2px', color:'rgba(167,139,250,.4)', marginBottom:12 }}>Koşullar & Açıklamalar</div>
                <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                  {satirlar.map((satir, i) => (
                    <div key={i} style={{ display:'flex', gap:12, padding:'14px', borderRadius:14, background:'rgba(255,255,255,.03)', border:'1px solid rgba(167,139,250,.08)', alignItems:'flex-start', position:'relative', overflow:'hidden', animation:`fadeUp .3s ${i * 0.07}s ease both` }}>
                      {/* Sol accent çizgi */}
                      <div style={{ position:'absolute', left:0, top:'10%', bottom:'10%', width:3, borderRadius:'0 3px 3px 0', background:`linear-gradient(180deg, #f27127, #a78bfa)` }} />
                      {/* Numara */}
                      <div style={{ width:24, height:24, borderRadius:8, background:'linear-gradient(135deg, rgba(242,113,39,.2), rgba(167,139,250,.15))', border:'1px solid rgba(242,113,39,.2)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:1 }}>
                        <span style={{ fontSize:'.62rem', fontWeight:800, color:'#f27127' }}>{i + 1}</span>
                      </div>
                      <p style={{ margin:0, fontSize:'.79rem', color:'rgba(240,238,255,.72)', lineHeight:1.7, paddingLeft:2 }}>
                        {satir.split('\n').map((line, li, arr) => (
                          <span key={li}>{line}{li < arr.length - 1 && <br />}</span>
                        ))}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Kapat butonu */}
          <div style={{ padding:'12px 22px 36px', flexShrink:0 }}>
            <button onClick={onKapat} style={{ width:'100%', padding:'14px', borderRadius:14, border:'1px solid rgba(167,139,250,.15)', background:'rgba(167,139,250,.07)', color:'rgba(167,139,250,.7)', fontSize:'.84rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit', transition:'all .18s', letterSpacing:'.2px' }}
              onMouseEnter={e => { e.currentTarget.style.background='rgba(167,139,250,.13)'; e.currentTarget.style.color='#a78bfa'; }}
              onMouseLeave={e => { e.currentTarget.style.background='rgba(167,139,250,.07)'; e.currentTarget.style.color='rgba(167,139,250,.7)'; }}>
              Kapat
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════
   ANA FORM
════════════════════════════════════════ */
class BonusTalepForm extends Component {
  state = {
    allData:[],secilenKategori:null,secilenBonus:null,
    gonderiliyor:false,yukleniyor:false,
    gecmis:[],oncekiGecmis:{},ilkYukleme:true,
    kullaniciAdi:'',detayBonus:null,
    aktifTab:'form',kopyalananId:null,tabGecis:false,
    kalanSure:0,
    destekAcik: false,
    oyunMenuAcik: false,
    verifyStatus: null,       // { found, hasDeposit }
    sayfaHazir: false,
  };

  _gecmisTimer = null;

  _mounted = false;

  componentDidMount() {
    if (this._mounted) return; // StrictMode çift mount koruması
    this._mounted = true;
    const username = new URLSearchParams(window.location.search).get('username')||'';
    this.setState({ kullaniciAdi:username }, () => this._ilkYukleme());
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this._gecmisTimer);
    clearInterval(this._cdiv);
  }

  _ilkYuklemeBasladi = false;

  _ilkYukleme = async () => {
    if (this._ilkYuklemeBasladi) return;
    this._ilkYuklemeBasladi = true;

    const { kullaniciAdi } = this.state;

    // 1) Bonus verileri çek (her zaman)
    try {
      const bonusRes = await axios.get(`${API}/bonus/selection-data?username=${kullaniciAdi}`);
      this.setState({ allData: bonusRes.data });
    } catch {}

    // 2) hasDeposit kontrolü
    let vs = { found: false, hasDeposit: true };
    if (kullaniciAdi) {
      try {
        const verifyRes = await axios.get(`${API}/bonus/verify-status?login=${kullaniciAdi}`);
        const vd = verifyRes.data;
        vs = {
          found: vd.found,
          hasDeposit: vd.hasDeposit ?? true,
        };
      } catch {}
    }
    this.setState({ verifyStatus: vs });

    // 3) Geçmiş çek
    await this.fetchGecmis();
    this.setState({ sayfaHazir: true });

    // 4) Geçmiş polling — her zaman 20sn
    this._gecmisTimer = setInterval(() => this.fetchGecmis(), 20000);
  };

  fetchData = async () => {
    try {
      const r = await axios.get(`${API}/bonus/selection-data?username=${this.state.kullaniciAdi}`);
      this.setState({ allData:r.data });
    } catch {}
  };

  _gecmisFetching = false;

  fetchGecmis = async () => {
    if (this._gecmisFetching) return; // Zaten çalışıyor, çift istek engelle
    this._gecmisFetching = true;

    const { kullaniciAdi,oncekiGecmis,ilkYukleme } = this.state;
    if (!kullaniciAdi) { this._gecmisFetching = false; return; }
    try {
      const r = await axios.get(`${API}/request/userThreeRequest?username=${kullaniciAdi}`);
      const yeni = r.data;
      if (!ilkYukleme) {
        yeni.forEach(item=>{
          const eski = oncekiGecmis[item._id];
          if (!eski||eski===item.status) return;
          if (item.status==='approved')
            notifMgr.emit({ type:'success',title:'🎉 Bonus Onaylandı!',body:`"${this.getBonusAdi(item.bonusType)}" bonusunuz onaylandı.` });
          else if (item.status==='rejected')
            notifMgr.emit({ type:'error',title:'❌ Bonus Reddedildi',body:item.rejectReason?`Neden: ${item.rejectReason}`:`"${this.getBonusAdi(item.bonusType)}" reddedildi.` });
          else
            notifMgr.emit({ type:'info',title:'⏳ Talep Güncellendi',body:'Durum: Beklemede' });
        });
      }
      const snap={};
      yeni.forEach(i=>{ snap[i._id]=i.status; });
      this.setState({ gecmis:yeni,oncekiGecmis:snap,ilkYukleme:false });

      // ── Cooldown: son talebin üzerinden 60sn geçmediyse geri sayım başlat ──
      if (yeni.length > 0) {
        const sonTarih  = new Date(yeni[0].createdAt).getTime();
        const gecenSn   = Math.floor((Date.now() - sonTarih) / 1000);
        const kalanSure = Math.max(60 - gecenSn, 0);
        this.setState({ kalanSure });
        clearInterval(this._cdiv);
        if (kalanSure > 0) {
          this._cdiv = setInterval(() => {
            this.setState(p => {
              const yeniKalan = Math.max(p.kalanSure - 1, 0);
              if (yeniKalan === 0) clearInterval(this._cdiv);
              return { kalanSure: yeniKalan };
            });
          }, 1000);
        }
      }
    } catch {} finally { this._gecmisFetching = false; }
  };

  getBonusAdi = (type) => {
    for (const cat of this.state.allData) {
      const f = cat.items?.find(b=>b.type===type?.toString());
      if (f) return f.name;
    }
    return type;
  };

  setTab = (tab) => {
    if (tab===this.state.aktifTab) return;
    this.setState({ tabGecis:true,aktifTab:tab });
    setTimeout(()=>this.setState({ tabGecis:false }),50);
  };

  gonder = async () => {
    const { kullaniciAdi, secilenBonus, kalanSure } = this.state;
    if (!secilenBonus) { notifMgr.emit({ type:'warn',title:'Bonus seçilmedi',body:'Lütfen önce bir bonus seçin.' }); return; }
    const bugunNo2 = new Date().getDay();
    const izinliGunler2 = secilenBonus.allowedDays || [];
    if (izinliGunler2.length > 0 && !izinliGunler2.includes(bugunNo2)) {
      const GUN2 = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
      notifMgr.emit({ type:'warn',title:'Bugün talep edilemez',body:`Bu bonus yalnızca ${izinliGunler2.map(g=>GUN2[g]).join(', ')} günleri talep edilebilir.` }); return;
    }
    if (kalanSure > 0) { notifMgr.emit({ type:'warn',title:'Çok hızlı!',body:`Yeni talep için ${kalanSure} saniye beklemeniz gerekiyor.` }); return; }
    this.setState({ gonderiliyor:true,yukleniyor:true });
    try {
      const r = await axios.post(`${API}/request/add?username=${kullaniciAdi}&bonustype=${secilenBonus.type}`);
      const msg = r.data?.message||'';
      if (msg.includes('başarılı')||msg.toLowerCase().includes('success')) {
        notifMgr.emit({ type:'success',title:'Talep Gönderildi ✓',body:`${secilenBonus.name} için talebiniz alındı.` });
        this.setState({ secilenBonus:null });
        this.setTab('gecmis');
      } else if (msg.includes('Bekleyen')) {
        notifMgr.emit({ type:'info',title:'Bekleyen Talep Var',body:'Önce mevcut talebinizin sonuçlanmasını bekleyin.' });
      } else {
        notifMgr.emit({ type:'warn',title:'Uyarı',body:msg });
      }
      this.fetchGecmis();
    } catch {
      notifMgr.emit({ type:'error',title:'Bağlantı Hatası',body:'Talep gönderilemedi, tekrar deneyin.' });
    } finally {
      this.setState({ gonderiliyor:false,yukleniyor:false });
    }
  };

  kopyalaRedNedeni = (item) => {
    kopyala(item.rejectReason,()=>{
      this.setState({ kopyalananId:item._id });
      notifMgr.emit({ type:'copy',title:'Kopyalandı ⎘',body:'Red nedeni panoya kopyalandı.' });
      setTimeout(()=>this.setState({ kopyalananId:null }),2000);
    });
  };

  formatTarih = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString('tr-TR',{day:'2-digit',month:'short'})+' '+d.toLocaleTimeString('tr-TR',{hour:'2-digit',minute:'2-digit'});
  };



  render() {
    const { allData,secilenKategori,secilenBonus,gonderiliyor,yukleniyor,gecmis,kullaniciAdi,detayBonus,aktifTab,kopyalananId,tabGecis,kalanSure,destekAcik,oyunMenuAcik,verifyStatus,sayfaHazir } = this.state;
    const bugunNo0 = new Date().getDay();

    // Yatırım yapmamış müşteriler sadece deneme bonusu kategorisini (categoryId: 3) görebilir
    const hasDeposit = !verifyStatus || verifyStatus.hasDeposit !== false;
    const filteredData = hasDeposit
      ? allData
      : allData.filter(cat => cat.categoryId === 3);

    const bonuslar = [...(secilenKategori?.items||[])].sort((a,b) => {
      const aKilitli = (a.allowedDays||[]).length > 0 && !(a.allowedDays||[]).includes(bugunNo0);
      const bKilitli = (b.allowedDays||[]).length > 0 && !(b.allowedDays||[]).includes(bugunNo0);
      return aKilitli === bKilitli ? 0 : aKilitli ? 1 : -1;
    });
    const bekleyenSayisi = gecmis.filter(g=>g.status==='pending').length;
    const cooldownAktif = kalanSure > 0;

    /* Kategori renk paleti — mor ağırlıklı, #131028'e uyumlu */
    const KAT_RENKLER = [
      { c:'#a78bfa', bg:'rgba(167,139,250', glow:'rgba(167,139,250,.22)' },
      { c:'#f27127', bg:'rgba(242,113,39',  glow:'rgba(242,113,39,.2)'   },
      { c:'#06b6d4', bg:'rgba(6,182,212',   glow:'rgba(6,182,212,.2)'    },
      { c:'#10b981', bg:'rgba(16,185,129',  glow:'rgba(16,185,129,.2)'   },
      { c:'#f472b6', bg:'rgba(244,114,182', glow:'rgba(244,114,182,.2)'  },
      { c:'#fbbf24', bg:'rgba(251,191,36',  glow:'rgba(251,191,36,.18)'  },
    ];

    return (
      <div style={{ minHeight:'100vh', background:`linear-gradient(160deg,${P.bgDeep} 0%,${P.bg} 60%,#110f26 100%)`, fontFamily:"'Outfit','Inter',sans-serif", paddingBottom:80 }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
          *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
          @keyframes notifIn   { from{opacity:0;transform:translateX(18px) scale(.95)} to{opacity:1;transform:none} }
          @keyframes fadeUp    { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:none} }
          @keyframes fadeLeft  { from{opacity:0;transform:translateX(18px)} to{opacity:1;transform:none} }
          @keyframes fadeRight { from{opacity:0;transform:translateX(-18px)} to{opacity:1;transform:none} }
          @keyframes sheetUp   { from{opacity:0;transform:translateY(32px)} to{opacity:1;transform:none} }
          @keyframes overlayIn { from{opacity:0} to{opacity:1} }
          @keyframes loadBar   { 0%{width:0%} 60%{width:72%} 100%{width:100%} }
          @keyframes pulseDot  { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.35;transform:scale(.6)} }
          @keyframes shimmer   { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
          @keyframes badgePop  { 0%{transform:scale(0)} 70%{transform:scale(1.25)} 100%{transform:scale(1)} }
          @keyframes copyFlash { 0%,100%{background:rgba(167,139,250,.1)} 50%{background:rgba(167,139,250,.25)} }
          @keyframes pbFill    { from{width:0%} to{width:var(--pw,70%)} }
          @keyframes pbPulse   { 0%,100%{opacity:1} 50%{opacity:.55} }
          @keyframes pbComplete{ from{width:var(--pw,70%)} to{width:100%} }
          @keyframes pbShimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
          @keyframes spinOnce   { 0%{transform:rotate(0deg) scale(1)} 50%{transform:rotate(-15deg) scale(1.2)} 100%{transform:rotate(0deg) scale(1)} }
          @keyframes floatIcon  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
          .kat-btn  { transition:all .18s; }
          .kat-btn:hover  { transform:translateY(-2px); }
          .kat-btn.ak     { transform:translateY(-2px); }
          .bon-kart { transition:all .16s; cursor:pointer; user-select:none; }
          .bon-kart:hover { transform:translateY(-2px); }
          .bon-kart.ak    { transform:translateY(-2px); }
          .gonder-btn { transition:all .18s; border:none; }
          .gonder-btn:hover:not(:disabled) { transform:translateY(-2px); filter:brightness(1.09); }
          .gonder-btn:disabled { cursor:not-allowed; }
          .tab-btn  { transition:all .18s; border:none; cursor:pointer; }
          .tab-btn:hover { color:#f0eeff !important; }
          .kopy-btn { transition:all .15s; border:none; cursor:pointer; }
          .kopy-btn:hover { filter:brightness(1.2); transform:scale(1.05); }

          .detay-lnk { cursor:pointer; transition:all .15s; }
          .detay-lnk:hover { color:rgba(240,238,255,.85) !important; background:rgba(255,255,255,.12) !important; border-color:rgba(255,255,255,.25) !important; }
          .detay-scroll::-webkit-scrollbar { width:3px; }
          .detay-scroll::-webkit-scrollbar-thumb { background:rgba(167,139,250,.2); border-radius:4px; }
          ::-webkit-scrollbar { width:3px; }
          ::-webkit-scrollbar-thumb { background:rgba(167,139,250,.2); border-radius:4px; }
        `}</style>

        <NotifOverlay />

        {/* ══ HEADER ══ */}
        <div style={{ background:`rgba(19,16,40,.85)`, borderBottom:`1px solid ${P.border}`, backdropFilter:'blur(20px)', position:'sticky', top:0, zIndex:200, padding:'13px 18px' }}>
          <div style={{ maxWidth:520,margin:'0 auto',display:'flex',alignItems:'center',justifyContent:'space-between',gap:10 }}>
            {/* Logo */}
            <div style={{ display:'flex',alignItems:'center',gap:10 }}>
              <div style={{ width:34,height:34,borderRadius:10,background:'linear-gradient(135deg,#f27127,#c44b0a)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1rem',boxShadow:'0 4px 14px rgba(242,113,39,.4)',flexShrink:0 }}>🎁</div>
              <div>
                <div style={{ fontSize:'.83rem',fontWeight:700,color:P.text,letterSpacing:'-.2px' }}>AntikBet</div>
                <div style={{ fontSize:'.58rem',color:P.textFaint,marginTop:1 }}>Bonus Talep Merkezi</div>
              </div>
            </div>

            {/* Oyunlara Devam Et dropdown */}
            <div style={{ position:'relative', flexShrink:0 }}>
              <button
                onClick={() => this.setState(p => ({ oyunMenuAcik: !p.oyunMenuAcik }))}
                style={{
                  display:'flex', alignItems:'center', gap:7, padding:'8px 13px',
                  borderRadius:22, cursor:'pointer', fontFamily:'inherit',
                  background: oyunMenuAcik
                    ? 'linear-gradient(135deg,#7c3aed,#a78bfa)'
                    : 'linear-gradient(135deg,rgba(124,58,237,.7),rgba(167,139,250,.5))',
                  border:'1px solid rgba(167,139,250,.4)',
                  boxShadow: oyunMenuAcik ? '0 0 22px rgba(167,139,250,.45)' : '0 0 14px rgba(167,139,250,.2)',
                  transition:'all .2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow='0 0 26px rgba(167,139,250,.55)'; e.currentTarget.style.transform='translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow= oyunMenuAcik ? '0 0 22px rgba(167,139,250,.45)' : '0 0 14px rgba(167,139,250,.2)'; e.currentTarget.style.transform='none'; }}
              >
                {/* Zar + kart emoji animasyonlu */}
                <span style={{ fontSize:'.88rem', lineHeight:1, animation: oyunMenuAcik ? 'none' : 'spinOnce .4s ease', display:'inline-block' }}>
                  {oyunMenuAcik ? '🎲' : '🎰'}
                </span>
                <span style={{ fontSize:'.72rem', fontWeight:800, color:'#fff', letterSpacing:'.2px', textShadow:'0 1px 6px rgba(0,0,0,.4)' }}>
                  Oyna!
                </span>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" style={{ transition:'transform .22s', transform: oyunMenuAcik ? 'rotate(180deg)' : 'none' }}>
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>

              {/* Dropdown menü */}
              {oyunMenuAcik && (
                <div
                  onClick={() => this.setState({ oyunMenuAcik: false })}
                  style={{ position:'fixed',inset:0,zIndex:299 }}
                />
              )}
              {oyunMenuAcik && (
                <div style={{
                  position:'absolute', top:'calc(100% + 10px)', right:0, zIndex:300, width:230,
                  background:'linear-gradient(160deg,#1e1640 0%,#150f2e 100%)',
                  border:'1px solid rgba(167,139,250,.25)',
                  borderRadius:16, overflow:'hidden',
                  boxShadow:'0 20px 60px rgba(0,0,0,.7), 0 0 0 1px rgba(167,139,250,.08), inset 0 1px 0 rgba(255,255,255,.06)',
                  animation:'fadeUp .18s ease both',
                }}>
                  {/* Başlık */}
                  <div style={{ padding:'10px 14px 8px', borderBottom:'1px solid rgba(255,255,255,.06)', display:'flex', alignItems:'center', gap:6 }}>
                    <span style={{ fontSize:'.75rem' }}>✨</span>
                    <span style={{ fontSize:'.62rem', fontWeight:700, color:'rgba(167,139,250,.6)', letterSpacing:'.8px', textTransform:'uppercase' }}>Oyunlara Geç</span>
                  </div>
                  {[
                    { ikon:'🎰', baslik:'Slot',         alt:'Çarklar dönmeye hazır!',       href:'https://tinyurl.com/antikbet/tr/casino/slots',  renk:'#a78bfa', bg:'linear-gradient(135deg,rgba(124,58,237,.15),rgba(167,139,250,.05))' },
                    { ikon:'🃏', baslik:'Canlı Casino',  alt:'Gerçek krupiyeler seni bekliyor', href:'https://tinyurl.com/antikbet/tr/live-casino/home', renk:'#f27127', bg:'linear-gradient(135deg,rgba(242,113,39,.15),rgba(251,146,60,.05))'  },
                    { ikon:'⚽', baslik:'Spor Bahisleri',alt:'Favori maçına kupon yap!',     href:'https://tinyurl.com/antikbet/tr/sports/live/', renk:'#10b981', bg:'linear-gradient(135deg,rgba(16,185,129,.15),rgba(52,211,153,.05))'  },
                  ].map((it,i,arr) => (
                    <a key={i} href={it.href}
                      onClick={() => this.setState({ oyunMenuAcik: false })}
                      style={{ display:'flex', alignItems:'center', gap:11, padding:'11px 14px', textDecoration:'none', borderBottom: i < arr.length-1 ? '1px solid rgba(255,255,255,.04)' : 'none', transition:'background .15s', position:'relative', overflow:'hidden' }}
                      onMouseEnter={e => { e.currentTarget.style.background = it.bg; e.currentTarget.querySelector('.arr').style.transform='translateX(3px)'; e.currentTarget.querySelector('.arr').style.opacity='1'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.querySelector('.arr').style.transform='none'; e.currentTarget.querySelector('.arr').style.opacity='.3'; }}
                    >
                      {/* İkon kutusu */}
                      <div style={{ width:36, height:36, borderRadius:10, background:`${it.renk}18`, border:`1px solid ${it.renk}30`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.05rem', flexShrink:0 }}>
                        {it.ikon}
                      </div>
                      {/* Metin */}
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:'.75rem', fontWeight:700, color:'rgba(240,238,255,.9)', lineHeight:1.2 }}>{it.baslik}</div>
                        <div style={{ fontSize:'.58rem', color:'rgba(240,238,255,.35)', marginTop:2, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{it.alt}</div>
                      </div>
                      {/* Ok */}
                      <svg className="arr" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={it.renk} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0, opacity:.3, transition:'all .15s' }}>
                        <path d="M5 12h14M13 6l6 6-6 6"/>
                      </svg>
                    </a>
                  ))}
                  {/* Alt dekor */}
                  <div style={{ padding:'8px 14px', borderTop:'1px solid rgba(255,255,255,.04)', display:'flex', alignItems:'center', justifyContent:'center', gap:4 }}>
                    <span style={{ fontSize:'.56rem', color:'rgba(240,238,255,.2)', letterSpacing:'.3px' }}>BTR</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Loading bar */}
        {yukleniyor && (
          <div style={{ height:3,background:`rgba(167,139,250,.15)` }}>
            <div style={{ height:'100%',background:'linear-gradient(90deg,transparent,#a78bfa,#c4b5fd,#a78bfa,transparent)',animation:'loadBar 1.4s ease forwards' }} />
          </div>
        )}

        {/* ══ SAYFA İÇERİĞİ ══ */}
        <div style={{ maxWidth:520,margin:'0 auto',padding:'20px 16px 0' }}>

          {/* ══ YÜKLEME EKRANI ══ */}
          {!sayfaHazir && (
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'60px 20px 80px', animation:'fadeUp .4s ease both' }}>
              {/* Animasyonlu ikon */}
              <div style={{
                width:72, height:72, borderRadius:22, marginBottom:24,
                background:'linear-gradient(135deg, rgba(167,139,250,.12), rgba(124,58,237,.08))',
                border:'1px solid rgba(167,139,250,.15)',
                display:'flex', alignItems:'center', justifyContent:'center',
                boxShadow:'0 8px 32px rgba(124,58,237,.15), 0 0 0 1px rgba(167,139,250,.06)',
                animation:'floatIcon 3s ease-in-out infinite',
              }}>
                <span style={{ fontSize:'1.8rem', display:'inline-block', animation:'spinOnce 2s ease infinite' }}>🎁</span>
              </div>

              {/* Başlık */}
              <div style={{ fontSize:'1rem', fontWeight:700, color:P.text, marginBottom:6, letterSpacing:'-.2px' }}>
                Bonus Talep Sayfası
              </div>
              <div style={{ fontSize:'.74rem', color:P.textFaint, marginBottom:28 }}>
                Yükleniyor...
              </div>

              {/* İnce loading bar */}
              <div style={{ width:'100%', maxWidth:200, height:4, borderRadius:99, background:'rgba(167,139,250,.08)', overflow:'hidden', marginBottom:16 }}>
                <div style={{
                  height:'100%', borderRadius:99, width:'65%',
                  background:'linear-gradient(90deg, #7c3aed, #a78bfa, #c4b5fd)',
                  backgroundSize:'200% 100%',
                  animation:'pbShimmer 1.8s linear infinite, loadBar 2s ease-in-out infinite alternate',
                  boxShadow:'0 0 8px rgba(167,139,250,.3)',
                }} />
              </div>

              {/* Alt not */}
              <div style={{ fontSize:'.6rem', color:'rgba(167,139,250,.25)' }}>
                Verileriniz hazırlanıyor
              </div>
            </div>
          )}

          {/* ══ ANA İÇERİK — sayfa hazır olduğunda ══ */}
          {sayfaHazir && (<>

          {/* Karşılama */}
          <div style={{ marginBottom:22,animation:'fadeUp .3s ease both' }}>
            <h1 style={{ fontSize:'1.25rem',fontWeight:800,color:P.text,letterSpacing:'-.4px',marginBottom:4 }}>
              {kullaniciAdi ? `Merhaba, ${kullaniciAdi} 👋` : 'Bonus Talebi'}
            </h1>
            <p style={{ fontSize:'.76rem',color:P.textFaint,lineHeight:1.6 }}>
              Bonus kategorisi seçin, ardından bonus türünüzü belirleyin.
            </p>
          </div>

          {/* TAB */}
          <div style={{ display:'flex',gap:4,padding:'5px',background:'rgba(167,139,250,.07)',borderRadius:14,border:`1px solid ${P.border}`,marginBottom:22,animation:'fadeUp .3s .05s ease both' }}>
            {[
              { key:'form',   label:'🎁 Bonus Talebi' },
              { key:'gecmis', label:'📋 Geçmişim', badge:bekleyenSayisi },
            ].map(t=>{
              const ak = aktifTab===t.key;
              return (
                <button key={t.key} className="tab-btn"
                  onClick={()=>this.setTab(t.key)}
                  style={{ flex:1,padding:'10px 12px',borderRadius:10,background:ak?'rgba(167,139,250,.15)':'transparent',color:ak?P.text:'rgba(240,238,255,.55)',fontSize:'.8rem',fontWeight:ak?700:500,fontFamily:'inherit',position:'relative' }}>
                  {t.label}
                  {t.badge>0 && (
                    <span style={{ position:'absolute',top:6,right:8,width:16,height:16,borderRadius:'50%',background:'#a78bfa',color:'#fff',fontSize:'.55rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',animation:'badgePop .3s cubic-bezier(.175,.885,.32,1.275)' }}>{t.badge}</span>
                  )}
                </button>
              );
            })}
          </div>

          {/* ══ FORM TABI ══ */}
          {aktifTab==='form' && (
            <div style={{ animation:tabGecis?'none':'fadeRight .28s cubic-bezier(.25,.46,.45,.94) both' }}>

              {/* Kategori grid */}
              <div style={{ marginBottom:22 }}>
                <div style={{ fontSize:'.62rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'1.2px',color:P.textFaint,marginBottom:12 }}>Bonus Kategorisi</div>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:10 }}>
                  {filteredData.length===0
                    ? [1,2,3,4].map(i=>(
                        <div key={i} style={{ height:70,borderRadius:16,backgroundImage:`linear-gradient(90deg,rgba(167,139,250,.03) 0%,rgba(167,139,250,.08) 50%,rgba(167,139,250,.03) 100%)`,backgroundSize:'200% 100%',animation:'shimmer 1.6s infinite' }} />
                      ))
                    : filteredData.map((cat,idx)=>{
                        const ak  = secilenKategori?.categoryId===cat.categoryId;
                        const ikon = katIcon(cat.name||cat.categoryName);
                        const renk = KAT_RENKLER[idx%KAT_RENKLER.length];
                        return (
                          <button key={cat.categoryId} className={`kat-btn${ak?' ak':''}`}
                            onClick={()=>this.setState({ secilenKategori:cat,secilenBonus:null })}
                            style={{
                              padding:'13px 14px',borderRadius:16,
                              background: ak
                                ? `linear-gradient(135deg, ${renk.bg},.16) 0%, ${renk.bg},.07) 100%)`
                                : P.card,
                              border:`1px solid ${ak ? `${renk.bg},.38)` : P.border}`,
                              boxShadow: ak ? `0 6px 24px ${renk.glow}, inset 0 1px 0 rgba(255,255,255,.06)` : 'none',
                              cursor:'pointer',fontFamily:'inherit',
                              display:'flex',flexDirection:'row',alignItems:'center',gap:0,
                              position:'relative',overflow:'hidden',textAlign:'left',
                            }}>
                            {ak && <div style={{ position:'absolute',top:-20,right:-20,width:70,height:70,borderRadius:'50%',background:`${renk.bg},.1)`,filter:'blur(18px)',pointerEvents:'none' }} />}
                            <div style={{ display:'flex',alignItems:'center',gap:10,width:'100%' }}>
                              <div style={{ width:36,height:36,borderRadius:10,flexShrink:0,
                                background: ak ? `${renk.bg},.18)` : 'rgba(255,255,255,.07)',
                                border:`1px solid ${ak ? `${renk.bg},.3)` : P.border}`,
                                display:'flex',alignItems:'center',justifyContent:'center',
                                fontSize:'1.05rem',lineHeight:1,
                                boxShadow: ak ? `0 4px 12px ${renk.glow}` : 'none',
                                transition:'all .18s',
                              }}>
                                {ikon}
                              </div>
                              <div style={{ minWidth:0 }}>
                                <div style={{ fontSize:'.78rem',fontWeight:700,color:ak?P.text:P.textSub,letterSpacing:'-.1px',marginBottom:1,transition:'color .15s',lineHeight:1.3 }}>
                                  {cat.name||cat.categoryName}
                                </div>
                                <div style={{ fontSize:'.62rem',color:ak?renk.c:P.textFaint,fontWeight:600,transition:'color .15s' }}>
                                  {(cat.items?.length||0)} bonus
                                </div>
                              </div>
                            </div>
                            {ak && (
                              <div style={{ position:'absolute',top:9,right:9,width:18,height:18,borderRadius:'50%',background:renk.c,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                              </div>
                            )}
                          </button>
                        );
                      })
                  }
                </div>
              </div>

              {/* Bonus listesi */}
              {secilenKategori && (
                <div style={{ marginBottom:22,animation:'fadeUp .22s ease both' }}>
                  <div style={{ fontSize:'.62rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'1.2px',color:P.textFaint,marginBottom:10,display:'flex',justifyContent:'space-between' }}>
                    <span>Bonus Seç</span>
                    <span style={{ fontWeight:400,textTransform:'none',letterSpacing:0,color:P.textFaint }}>{bonuslar.length} seçenek</span>
                  </div>
                  <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
                    {bonuslar.map(bonus=>{
                      const ak = secilenBonus?.type===bonus.type;
                      // Gün kısıtlaması
                      const bugunNo = new Date().getDay(); // 0=Paz,1=Pzt...
                      const izinliGunler = bonus.allowedDays || [];
                      const gunKilitli = izinliGunler.length > 0 && !izinliGunler.includes(bugunNo);
                      const GUN_ISIMLERI = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
                      const gunEtiketi = izinliGunler.map(g=>GUN_ISIMLERI[g]).join(', ');

                      const kilitli = gunKilitli;

                      return (
                        <div key={bonus.type} className={`bon-kart${ak?' ak':''}`}
                          onClick={()=>{
                            if (gunKilitli) return;
                            this.setState(p=>({ secilenBonus:p.secilenBonus?.type===bonus.type?null:bonus }));
                          }}
                          style={{ padding:'13px 15px',borderRadius:14,
                            border:`1px solid ${kilitli?'rgba(239,68,68,.12)':ak?'rgba(242,113,39,.42)':P.border}`,
                            background:kilitli?'rgba(239,68,68,.04)':ak?P.accentDim:P.card,
                            display:'flex',alignItems:'center',gap:12,
                            boxShadow:ak&&!kilitli?`0 6px 20px ${P.accentGlow}`:'none',
                            position:'relative',overflow:'hidden',
                            opacity: kilitli ? .55 : 1,
                            cursor: kilitli ? 'default' : 'pointer',
                          }}>
                          {ak && !kilitli && <div style={{ position:'absolute',left:0,top:0,bottom:0,width:3,background:'linear-gradient(180deg,#f27127,#c44b0a)',borderRadius:'0 3px 3px 0' }} />}
                          {kilitli && <div style={{ position:'absolute',left:0,top:0,bottom:0,width:3,background:'linear-gradient(180deg,#ef4444,#dc2626)',borderRadius:'0 3px 3px 0',opacity:.5 }} />}
                          <div style={{ flex:1,paddingLeft:4,minWidth:0 }}>
                            <div style={{ fontSize:'.84rem',fontWeight:600,color:kilitli?'rgba(240,238,255,.35)':ak?P.text:'rgba(240,238,255,.7)',marginBottom:4 }}>{bonus.name}</div>
                            <div style={{ display:'flex',gap:7,alignItems:'center',flexWrap:'wrap' }}>
                              {bonus.bonusPercent>0 && <span style={{ fontSize:'.62rem',padding:'2px 7px',borderRadius:6,background:kilitli?'rgba(255,255,255,.04)':'rgba(251,191,36,.1)',border:kilitli?'1px solid rgba(255,255,255,.08)':'1px solid rgba(251,191,36,.22)',color:kilitli?'rgba(240,238,255,.25)':'#fbbf24',fontWeight:700 }}>%{bonus.bonusPercent}</span>}
                              {bonus.minDepositAmount>0 && <span style={{ fontSize:'.63rem',color:kilitli?'rgba(240,238,255,.2)':P.textFaint }}>Min. {bonus.minDepositAmount?.toLocaleString('tr-TR')} ₺</span>}
                              {gunKilitli && (
                                <span style={{ display:'flex',alignItems:'center',gap:4,fontSize:'.62rem',color:'#4ade80',padding:'2px 8px',borderRadius:6,background:'rgba(74,222,128,.1)',border:'1px solid rgba(74,222,128,.25)',fontWeight:600 }}>
                                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                                  {gunEtiketi}
                                </span>
                              )}
                            </div>
                          </div>
                          <div style={{ display:'flex',alignItems:'center',gap:8,flexShrink:0 }}>
                            {!kilitli && (
                              <span className="detay-lnk"
                                onClick={e=>{e.stopPropagation();this.setState({ detayBonus:bonus });}}
                                style={{ display:'flex',alignItems:'center',gap:4,fontSize:'.63rem',
                                  color: ak ? 'rgba(255,255,255,.55)' : 'rgba(240,238,255,.38)',
                                  padding:'4px 10px',borderRadius:8,
                                  border: ak ? '1px solid rgba(255,255,255,.18)' : '1px solid rgba(255,255,255,.09)',
                                  background: ak ? 'rgba(255,255,255,.08)' : 'rgba(255,255,255,.04)',
                                  fontWeight:500,letterSpacing:'.2px',transition:'all .15s' }}>
                                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{opacity:.7}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                Detay
                              </span>
                            )}
                            {kilitli
                              ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(239,68,68,.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                              : <div style={{ width:20,height:20,borderRadius:'50%',border:`2px solid ${ak?P.accent:P.borderStr}`,background:ak?P.accent:'transparent',display:'flex',alignItems:'center',justifyContent:'center',transition:'all .15s',flexShrink:0 }}>
                                  {ak && <div style={{ width:7,height:7,borderRadius:'50%',background:'#fff' }} />}
                                </div>
                            }
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Gönder */}
              <button className="gonder-btn" onClick={this.gonder} disabled={gonderiliyor||!secilenBonus||cooldownAktif}
                style={{
                  width:'100%',padding:'15px',borderRadius:14,fontFamily:'inherit',
                  border: cooldownAktif ? '1px solid rgba(167,139,250,.18)' : 'none',
                  background: cooldownAktif
                    ? 'rgba(167,139,250,.07)'
                    : secilenBonus
                      ? 'linear-gradient(135deg,#f27127,#c44b0a)'
                      : 'rgba(255,255,255,.06)',
                  color: cooldownAktif ? 'rgba(167,139,250,.6)' : secilenBonus ? '#fff' : P.textFaint,
                  fontSize:'.88rem',fontWeight:700,
                  cursor: (cooldownAktif||!secilenBonus) ? 'not-allowed' : 'pointer',
                  boxShadow: secilenBonus && !cooldownAktif ? `0 6px 22px ${P.accentGlow}` : 'none',
                  transition:'all .18s',
                }}>
                {gonderiliyor
                  ? '⏳ Gönderiliyor...'
                  : cooldownAktif
                    ? <span style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:10 }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        {`${kalanSure}s sonra tekrar gönderebilirsiniz`}
                      </span>
                    : secilenBonus ? 'Talebi Gönder →' : 'Bonus Seçin'
                }
              </button>
            </div>
          )}

          {/* ══ GEÇMİŞ TABI ══ */}
          {aktifTab==='gecmis' && (
            <div style={{ animation:tabGecis?'none':'fadeLeft .28s cubic-bezier(.25,.46,.45,.94) both' }}>
              <div style={{ fontSize:'.62rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'1.2px',color:P.textFaint,marginBottom:14 }}>Son Talepler</div>

              {gecmis.length===0 ? (
                <div style={{ textAlign:'center',padding:'50px 20px',color:P.textFaint,fontSize:'.82rem' }}>
                  <div style={{ fontSize:'2.5rem',marginBottom:12 }}>📋</div>
                  Henüz bonus talebiniz bulunmuyor.
                </div>
              ) : (
                <div style={{ display:'flex',flexDirection:'column',gap:10 }}>
                  {(() => {
                    /* ── Paylaşımlı parse + kart renderer ── */
                    const parseBonus = (metin) => {
                      const s = metin.trim();
                      const bm = s.match(/^([^\-\n;]+?)(?:\s*[-;]\s*|\s*;\s*\n)([\s\S]+)$/);
                      const baslik = bm ? bm[1].trim() : null;
                      const govde  = bm ? bm[2].trim() : s;
                      // Haftalık bilgi: Yatırım: X | Çekim: Y | Bonus: Z | <metin>
                      const phb = govde.match(/[Yy]at[ıi]r[ıi]m\s*:\s*([\d,.]+)\s*\|\s*[Çç]ekim\s*:\s*([\d,.]+)\s*\|\s*[Bb]onus\s*:\s*([\d,.]+)\s*\|\s*(.*)/i);
                      if (phb) return { tip:'haftalik_bilgi', baslik, yatirim:phb[1], cekim:phb[2], mevcutBonus:phb[3], mesaj:phb[4].trim() };
                      // Haftalık onay v2: Yatırım: X | Çekim: Y = Z | Bonus: W TL'lik fark için N TL bonus
                      const ph2 = govde.match(/[Yy]at[ıi]r[ıi]m\s*:\s*([\d,.]+)\s*\|\s*[Çç]ekim\s*:\s*([\d,.]+)\s*=\s*[\d,.]+\s*\|\s*[Bb]onus\s*:\s*([\d,.]+)\s*TL[^\s]*\s*fark\s*i[çc]in\s*([\d,.]+)\s*TL\s*bonus/i);
                      if (ph2) return { tip:'haftalik', baslik, yatirim:ph2[1], cekim:ph2[2], mevcutBonus:ph2[3], eklenen:ph2[4] };
                      // Haftalık onay v1: Yatırım: X | Çekim: Y | Bonus: Z = ... fark için N TL bonus
                      const ph = govde.match(/[Yy]at[ıi]r[ıi]m\s*:\s*([\d,.]+)\s*\|\s*[Çç]ekim\s*:\s*([\d,.]+)\s*\|\s*[Bb]onus\s*:\s*([\d,.]+)\s*=\s*[\d,.]+\s*TL[^\s]*\s*fark\s*i[çc]in\s*([\d,.]+)\s*TL\s*bonus/i);
                      if (ph) return { tip:'haftalik', baslik, yatirim:ph[1], cekim:ph[2], mevcutBonus:ph[3], eklenen:ph[4] };
                      // Yatırım: X | Çekim: Y | <açıklama metni>
                      const p0 = govde.match(/[Yy]at[ıi]r[ıi]m\s*:\s*([\d,.]+)\s*\|\s*[Çç]ekim\s*:\s*([\d,.]+)\s*\|\s*(.*)/i);
                      if (p0) return { tip:'bilgi', baslik, yatirim:p0[1], cekim:p0[2], mesaj:p0[3].trim() };
                      const p1 = govde.match(/[Yy]at[ıi]r[ıi]m\s*:\s*([\d,.]+)\s*\|\s*[Çç]ekim\s*:\s*([\d,.]+)\s*=\s*[\d,.]+\s*TL[^\s]*\s*fark\s*i[çc]in\s*([\d,.]+)\s*TL\s*bonus/i);
                      if (p1) return { tip:'kayip', baslik, yatirim:p1[1], cekim:p1[2], bonus:p1[3] };
                      const p2 = govde.match(/([\d,.]+)\s*TL\s*yat[ıi]r[ıi]m\s*i[çc]in\s*([\d,.]+)\s*TL\s*bonus/i);
                      if (p2) return { tip:'bonus_tl', baslik, yatirim:p2[1], bonus:p2[2] };
                      const p3 = govde.match(/([\d,.]+)\s*TL\s*yat[ıi]r[ıi]m\s*i[çc]in\s*([\d,.]+)\s*(Freespin|Freebet)/i);
                      if (p3) return { tip:'spin_yatirim', baslik, yatirim:p3[1], adet:p3[2], tur:p3[3] };
                      const p4 = govde.match(/([\d,.]+)\s*(Freespin|Freebet)\s*eklendi/i);
                      if (p4) return { tip:'spin_direkt', baslik, adet:p4[1], tur:p4[2] };
                      return { tip:'metin', baslik, metin: s };
                    };

                    /* SVG ikonları */
                    const IkonYatirim = ({renk}) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M12 20V4" stroke={renk} strokeWidth="1.9" strokeLinecap="round"/>
                        <path d="M5 11l7-7 7 7" stroke={renk} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    );
                    const IkonCekim = ({renk}) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M12 4v16" stroke={renk} strokeWidth="1.9" strokeLinecap="round"/>
                        <path d="M5 13l7 7 7-7" stroke={renk} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    );
                    const IkonBonus = ({renk}) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" stroke={renk} strokeWidth="1.8"/>
                        <path d="M12 7v1.5M12 15.5V17" stroke={renk} strokeWidth="1.8" strokeLinecap="round"/>
                        <path d="M9.5 9.5a2.5 2.5 0 015 0c0 1.5-1 2-2.5 2.5S9 13.5 9 15h6" stroke={renk} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    );
                    const IkonSpin = ({renk}) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="7" width="20" height="13" rx="2.5" stroke={renk} strokeWidth="1.8"/>
                        <line x1="9" y1="7" x2="9" y2="20" stroke={renk} strokeWidth="1.5"/>
                        <line x1="15" y1="7" x2="15" y2="20" stroke={renk} strokeWidth="1.5"/>
                        <circle cx="6" cy="13.5" r="2" fill={renk} opacity=".9"/>
                        <rect x="10.5" y="11.5" width="3" height="4" rx="1" fill={renk} opacity=".9"/>
                        <path d="M16 12l1.5 1.5L16 15" stroke={renk} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M17 4h2a1 1 0 011 1v2h-4V5a1 1 0 011-1z" stroke={renk} strokeWidth="1.5"/>
                      </svg>
                    );
                    const IkonFreebet = ({renk}) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" stroke={renk} strokeWidth="1.7"/>
                        <path d="M12 3c0 0-3 3.5-3 9s3 9 3 9" stroke={renk} strokeWidth="1.3" opacity=".5"/>
                        <path d="M3 12h18" stroke={renk} strokeWidth="1.3" opacity=".5"/>
                        <polygon points="12,6 14.5,9.5 12,13 9.5,9.5" stroke={renk} strokeWidth="1.4" fill="none"/>
                        <path d="M9.5 9.5L7 8M14.5 9.5L17 8M12 13v3" stroke={renk} strokeWidth="1.2" strokeLinecap="round" opacity=".7"/>
                      </svg>
                    );

                    const renderKartlar = (parsed, tema) => {
                      const isRed = tema === 'red';
                      /* Renk tanımları */
                      const RENKLER = isRed ? {
                        yatirim:      { renk:'#f87171', glow:'rgba(248,113,113,.16)' },
                        cekim:        { renk:'#fb923c', glow:'rgba(251,146,60,.13)' },
                        bonus:        { renk:'#fca5a5', glow:'rgba(252,165,165,.12)' },
                        mevcut_bonus: { renk:'#c4b5fd', glow:'rgba(196,181,253,.12)' },
                        spin:         { renk:'#f87171', glow:'rgba(248,113,113,.14)' },
                        freebet:      { renk:'#fb923c', glow:'rgba(251,146,60,.13)' },
                      } : {
                        yatirim:       { renk:'#10b981', glow:'rgba(16,185,129,.16)' },
                        cekim:         { renk:'#f87171', glow:'rgba(248,113,113,.12)' },
                        bonus:         { renk:'#fbbf24', glow:'rgba(251,191,36,.18)' },
                        mevcut_bonus:  { renk:'#a78bfa', glow:'rgba(167,139,250,.15)' },
                        spin:          { renk:'#fbbf24', glow:'rgba(251,191,36,.18)' },
                        freebet:       { renk:'#fbbf24', glow:'rgba(251,191,36,.18)' },
                      };

                      if (parsed.tip === 'metin') {
                        return <div style={{ fontSize:'.75rem', color: isRed ? '#fca5a5' : '#6ee7b7', lineHeight:1.6 }}>{parsed.metin}</div>;
                      }

                      const isSpin = parsed.tip === 'spin_direkt' || parsed.tip === 'spin_yatirim';
                      const isFreebet = parsed.tur?.toLowerCase() === 'freebet';
                      const spinRenk = isFreebet ? RENKLER.freebet : RENKLER.spin;

                      const kartlar = [];
                      if (parsed.tip === 'bilgi') {
                        kartlar.push(
                          { label:'Yatırım', val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`, Ikon:IkonYatirim, ...RENKLER.yatirim },
                          { label:'Çekim',   val:`${parseFloat(parsed.cekim).toLocaleString('tr-TR')} ₺`,   Ikon:IkonCekim,   ...RENKLER.cekim },
                        );
                      } else if (parsed.tip === 'haftalik') {
                        kartlar.push(
                          { label:'Yatırım',         val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`,    Ikon:IkonYatirim, ...RENKLER.yatirim },
                          { label:'Çekim',           val:`${parseFloat(parsed.cekim).toLocaleString('tr-TR')} ₺`,      Ikon:IkonCekim,   ...RENKLER.cekim },
                          { label:'Alınan Bonus',    val:`${parseFloat(parsed.mevcutBonus).toLocaleString('tr-TR')} ₺`,Ikon:IkonBonus,   ...RENKLER.mevcut_bonus },
                          { label:'Eklenen Bonus', val:`${parseFloat(parsed.eklenen).toLocaleString('tr-TR')} ₺`,    Ikon:IkonBonus,   ...RENKLER.bonus },
                        );
                      } else if (parsed.tip === 'haftalik_bilgi') {
                        kartlar.push(
                          { label:'Yatırım',      val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`,    Ikon:IkonYatirim, ...RENKLER.yatirim },
                          { label:'Çekim',        val:`${parseFloat(parsed.cekim).toLocaleString('tr-TR')} ₺`,      Ikon:IkonCekim,   ...RENKLER.cekim },
                          { label:'Alınan Bonus', val:`${parseFloat(parsed.mevcutBonus).toLocaleString('tr-TR')} ₺`,Ikon:IkonBonus,   ...RENKLER.mevcut_bonus },
                        );
                      } else if (parsed.tip === 'kayip') {
                        kartlar.push(
                          { label:'Yatırım', val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`, Ikon:IkonYatirim, ...RENKLER.yatirim },
                          { label:'Çekim',   val:`${parseFloat(parsed.cekim).toLocaleString('tr-TR')} ₺`,   Ikon:IkonCekim,   ...RENKLER.cekim },
                          { label:'Eklenen Bonus', val:`${parseFloat(parsed.bonus).toLocaleString('tr-TR')} ₺`, Ikon:IkonBonus, ...RENKLER.bonus, full:true },
                        );
                      } else if (parsed.tip === 'bonus_tl') {
                        kartlar.push(
                          { label:'Yatırım',         val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`, Ikon:IkonYatirim, ...RENKLER.yatirim },
                          { label:'Eklenen Bonus', val:`${parseFloat(parsed.bonus).toLocaleString('tr-TR')} ₺`,   Ikon:IkonBonus,   ...RENKLER.bonus },
                        );
                      } else if (parsed.tip === 'spin_yatirim') {
                        kartlar.push(
                          { label:'Yatırım',           val:`${parseFloat(parsed.yatirim).toLocaleString('tr-TR')} ₺`, Ikon:IkonYatirim,                         ...RENKLER.yatirim },
                          { label:`Eklenen ${parsed.tur}`, val:parseFloat(parsed.adet).toLocaleString('tr-TR'),         Ikon:isFreebet?IkonFreebet:IkonSpin, ...spinRenk },
                        );
                      } else if (parsed.tip === 'spin_direkt') {
                        kartlar.push(
                          { label:`Eklenen ${parsed.tur}`, val:parseFloat(parsed.adet).toLocaleString('tr-TR'), Ikon:isFreebet?IkonFreebet:IkonSpin, ...spinRenk, full:true },
                        );
                      }

                      return (
                        <div>
                          {parsed.baslik && (
                            <div style={{ fontSize:'.62rem',fontWeight:700,color: isRed ? 'rgba(248,113,113,.5)' : 'rgba(16,185,129,.5)',textTransform:'uppercase',letterSpacing:'.8px',marginBottom:10 }}>
                              {parsed.baslik}
                            </div>
                          )}
                          {(parsed.tip === 'bilgi' || parsed.tip === 'haftalik_bilgi') && parsed.mesaj && (
                            <div style={{ fontSize:'.7rem', color: isRed ? '#fca5a5' : 'rgba(240,238,255,.55)', lineHeight:1.5, marginBottom:7, padding:'7px 10px', borderRadius:8, background: isRed ? 'rgba(248,113,113,.06)' : 'rgba(255,255,255,.04)', border: `1px solid ${isRed ? 'rgba(248,113,113,.14)' : 'rgba(255,255,255,.07)'}` }}>
                              {parsed.mesaj}
                            </div>
                          )}
                          <div style={{ display:'grid', gridTemplateColumns: kartlar.length===1 ? '1fr' : '1fr 1fr', gap:5 }}>
                            {kartlar.map((k,ki) => (
                              <div key={ki} style={{
                                padding:'7px 9px', borderRadius:9,
                                background:`linear-gradient(135deg, ${k.glow}, rgba(255,255,255,.02))`,
                                border:`1px solid ${k.renk}28`,
                                gridColumn: k.full ? '1/-1' : undefined,
                                display:'flex', alignItems:'center', gap:7,
                                position:'relative', overflow:'hidden',
                              }}>
                                <div style={{ position:'absolute',top:-8,right:-8,width:30,height:30,borderRadius:'50%',background:k.glow,filter:'blur(10px)',pointerEvents:'none' }} />
                                <div style={{ width:26,height:26,borderRadius:7,background:`${k.glow}`,border:`1px solid ${k.renk}22`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                                  <k.Ikon renk={k.renk} />
                                </div>
                                <div>
                                  <div style={{ fontSize:'.52rem',color:'rgba(240,238,255,.22)',textTransform:'uppercase',letterSpacing:'.6px',marginBottom:2 }}>{k.label}</div>
                                  <div style={{ fontSize:'.82rem',fontWeight:800,color:k.renk,letterSpacing:'-.2px',lineHeight:1 }}>{k.val}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    };

                    return gecmis.map((item,idx)=>{
                    const st = ({
                      approved:{ color:'#10b981',bg:'rgba(16,185,129,.1)', border:'rgba(16,185,129,.25)',label:'Onaylandı', dot:'#10b981',pulse:false },
                      rejected:{ color:'#f87171',bg:'rgba(248,113,113,.1)',border:'rgba(248,113,113,.25)',label:'Reddedildi',dot:'#f87171',pulse:false },
                      pending: { color:'#a78bfa',bg:'rgba(167,139,250,.1)',border:'rgba(167,139,250,.25)',label:'Beklemede', dot:'#a78bfa',pulse:true  },
                    })[item.status]||{ color:'#94a3b8',bg:'rgba(148,163,184,.08)',border:'rgba(148,163,184,.2)',label:item.status,dot:'#94a3b8',pulse:false };

                    const kopyalandi = kopyalananId===item._id;
                    return (
                      <div key={item._id||idx} style={{ borderRadius:15,background:P.card,border:`1px solid ${P.border}`,overflow:'hidden',animation:`fadeUp .25s ${idx*0.07}s ease both` }}>
                        <div style={{ padding:'13px 15px',display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:10,position:'relative' }}>
                          <div style={{ position:'absolute',left:0,top:'15%',bottom:'15%',width:3,borderRadius:'0 3px 3px 0',background:st.dot,boxShadow:`0 0 8px ${st.dot}70` }} />
                          <div style={{ flex:1,minWidth:0,paddingLeft:10 }}>
                            <div style={{ fontSize:'.84rem',fontWeight:600,color:P.text,marginBottom:5,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>
                              {this.getBonusAdi(item.bonusType)}
                            </div>
                            <div style={{ fontSize:'.67rem',color:P.textFaint }}>{this.formatTarih(item.createdAt)}</div>
                          </div>
                          <div style={{ display:'flex',alignItems:'center',gap:7,flexShrink:0 }}>
                            <span style={{ display:'inline-flex',alignItems:'center',gap:5,padding:'5px 11px',borderRadius:9,background:st.bg,border:`1px solid ${st.border}`,color:st.color,fontSize:'.66rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',whiteSpace:'nowrap' }}>
                              <span style={{ width:5,height:5,borderRadius:'50%',background:st.dot,display:'inline-block',animation:st.pulse?'pulseDot 1.5s infinite':'none' }} />
                              {st.label}
                            </span>
                            {item.status==='rejected' && item.rejectReason && (
                              <button className="kopy-btn"
                                onClick={()=>this.kopyalaRedNedeni(item)}
                                title="Red nedenini kopyala"
                                style={{ width:28,height:28,borderRadius:8,background:kopyalandi?P.purpleDim:P.card,border:`1px solid ${kopyalandi?'rgba(167,139,250,.4)':P.border}`,color:kopyalandi?P.purple:P.textFaint,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,animation:kopyalandi?'copyFlash .6s ease':'none' }}>
                                {kopyalandi
                                  ? <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#a78bfa" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                  : <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2"/></svg>
                                }
                              </button>
                            )}
                          </div>
                        </div>

                        {item.status==='rejected' && item.rejectReason && (() => {
                          const parsed = parseBonus(item.rejectReason);
                          const isKart = parsed.tip !== 'metin';
                          return (
                            <div style={{ padding:'9px 12px 11px',borderTop:'1px solid rgba(248,113,113,.1)',background:'rgba(248,113,113,.03)' }}>
                              <div style={{ fontSize:'.56rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'.8px',color:'rgba(248,113,113,.45)',marginBottom:7 }}>
                                ✕ Red Nedeni
                              </div>
                              {isKart
                                ? renderKartlar(parsed, 'red')
                                : <div style={{ fontSize:'.75rem',color:'#fca5a5',lineHeight:1.6 }}>{item.rejectReason}</div>
                              }
                            </div>
                          );
                        })()}

                        {item.status==='approved' && (item.rejectReason || item.adminNote) && (() => {
                          const notMetni = item.adminNote || item.rejectReason || '';
                          const parsed   = parseBonus(notMetni);
                          return (
                            <div style={{ padding:'9px 12px 11px',borderTop:'1px solid rgba(16,185,129,.1)',background:'rgba(16,185,129,.03)' }}>
                              <div style={{ fontSize:'.56rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'.8px',color:'rgba(16,185,129,.45)',marginBottom:7 }}>
                                🎉 Bonus Detayı
                              </div>
                              {renderKartlar(parsed, 'green')}
                            </div>
                          );
                        })()}

                        {/* ── PROGRESS BAR ── */}
                        {item.status === 'pending' && (
                          <PendingBar createdAt={item.createdAt} />
                        )}

                      </div>
                    );
                  });
                  })()}
                </div>
              )}
            </div>
          )}

          </>)}
        </div>

        <BonusDetayModal bonus={detayBonus} onKapat={()=>this.setState({ detayBonus:null })} />


      </div>
    );
  }
}

export default BonusTalepForm;